export default __webpack_public_path__ + "download-pdf.svg";